import { useCallback, useEffect, useState } from 'react'
import { api, type DomainHit } from '../adminApi'
import { fmtAgoUnix } from '../format'

export function Sites() {
  const [rows, setRows] = useState<DomainHit[]>([])
  const [gen, setGen] = useState(0)
  const [loading, setLoading] = useState(true)
  const [err, setErr] = useState<string | null>(null)
  const [q, setQ] = useState('')

  const load = useCallback(async () => {
    try { const r = await api.domains(); setRows(r.overall); setGen(r.generatedAt); setErr(null) }
    catch { setErr('Не удалось загрузить сайты.') }
    finally { setLoading(false) }
  }, [])

  useEffect(() => {
    load()
    const id = window.setInterval(load, 60000)
    return () => clearInterval(id)
  }, [load])

  if (loading) return <div className="empty"><span className="spin" /></div>
  if (err) return <div className="alert err">{err}</div>

  const s = q.trim().toLowerCase()
  const list = rows.filter((r) => !s || r.domain.toLowerCase().includes(s))
  const max = list.length ? Math.max(...list.map((r) => r.hits)) : 1

  return (
    <>
      <div className="muted" style={{ fontSize: 12.5, marginBottom: 10 }}>
        Топ доменов по всей сети (из access-лога). {gen ? `обновлено ${fmtAgoUnix(gen)}` : ''}
      </div>
      <input className="input" placeholder="Фильтр по домену…" value={q} onChange={(e) => setQ(e.target.value)} style={{ marginBottom: 12 }} />
      {list.length === 0 ? (
        <div className="card panel empty"><p>Пока нет данных по доменам.</p></div>
      ) : (
        <div className="card panel" style={{ display: 'grid', gap: 6 }}>
          {list.map((r, i) => (
            <div key={r.domain} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12.5 }}>
              <span className="muted" style={{ minWidth: 22, textAlign: 'right', fontSize: 11.5 }}>{i + 1}</span>
              <span className="mono" style={{ flex: '1 1 0', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.domain}</span>
              <span style={{ width: 60, flex: 'none', height: 8, background: 'var(--line)', borderRadius: 4, overflow: 'hidden' }}>
                <span style={{ display: 'block', height: '100%', width: `${(r.hits / max) * 100}%`, background: 'var(--accent)', opacity: 0.55 }} />
              </span>
              <span className="muted mono" style={{ minWidth: 40, textAlign: 'right' }}>{r.hits}</span>
            </div>
          ))}
        </div>
      )}
    </>
  )
}
